import { A as AppForm, a as AppSubmitButton } from './AppSubmitButton-2e6a9268.esm.js';
import { C as Constants, a as AppErrorMessage, A as AppFormField } from './AppFormField-e5fa211c.esm.js';
import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default, { useRef, useState, useEffect, Component } from 'react';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { A as AppText } from './index-6b88191c.esm.js';
import { A as AppInputLabel } from './index-5ae71f5a.esm.js';
import { View } from 'react-native';
import { useFormikContext } from 'formik';
import { A as AppMultipleSelection, a as AppMultipleSelectionItem } from './index-35300242.esm.js';
import { A as AppFormPicker } from './AppFormPicker-04baca06.esm.js';
import { A as AppSwitch } from './index-dbc9bff8.esm.js';
import { A as AppDropDown } from './index-db6cb3b9.esm.js';
import { A as AppRadio } from './index-0e71a535.esm.js';
import { A as AppFormCodeInput } from './AppFormCodeInput-87bc5844.esm.js';
import { A as AppSecureTextInput } from './index-eddb20d6.esm.js';
import { A as AppMultipleSelectInput } from './index-7390c975.esm.js';
import JSONEditor from 'jsoneditor';
import _ from 'lodash';
import { A as AppCodeEditor } from './index-eb4b55d5.esm.js';
import * as Yup from 'yup';

const AppJSONEditor = _ref => {
  let {
    schema,
    onValueChange = () => {},
    json = {},
    errorStyle,
    errorWrapperStyle,
    width = "100%",
    wrapperContainer = {},
    height = "300px",
    showTextInputLabel,
    textInputLabelStyle,
    isMandatory,
    label,
    ...props
  } = _ref;
  const jsonEditorRef = useRef(null);
  const [query, setQuery] = useState(null);
  const [errors, setErrors] = useState("");
  const validateJson = async json => {
    try {
      if (schema) {
        await schema.validate(json);
        setErrors("");
      }
    } catch (error) {
      setErrors(error.message);
    }
  };
  const validateObject = event => {
    if (event.jsObject) {
      validateJson(event.jsObject);
    } else {
      var _jsonEditorRef$curren, _jsonEditorRef$curren2, _jsonEditorRef$curren3;
      setErrors((_jsonEditorRef$curren = jsonEditorRef.current) === null || _jsonEditorRef$curren === void 0 ? void 0 : (_jsonEditorRef$curren2 = _jsonEditorRef$curren.state) === null || _jsonEditorRef$curren2 === void 0 ? void 0 : (_jsonEditorRef$curren3 = _jsonEditorRef$curren2.error) === null || _jsonEditorRef$curren3 === void 0 ? void 0 : _jsonEditorRef$curren3.reason);
    }
  };
  // if json is a string then convert it to json object
  const _json = typeof json === "string" ? JSON.parse(json) : json;
  return /*#__PURE__*/React__default.createElement("div", {
    style: wrapperContainer
  }, showTextInputLabel ? /*#__PURE__*/React__default.createElement(AppInputLabel, {
    style: [{
      marginLeft: 20
    }, textInputLabelStyle],
    isMandatory: isMandatory,
    label: label
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), /*#__PURE__*/React__default.createElement(JSONInput, _extends({}, props, {
    ref: jsonEditorRef,
    id: "json_editor",
    locale: locale,
    placeholder: _json,
    onChange: object => {
      setQuery(object.jsObject);
      validateObject(object);
      onValueChange(object);
    },
    width: width,
    height: height
  })), errors && /*#__PURE__*/React__default.createElement(AppText, {
    style: errorStyle,
    wrapperStyle: errorWrapperStyle
  }, errors));
};
AppJSONEditor.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppJSONEditor",
  "props": {
    "onValueChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "json": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "\"100%\"",
        "computed": false
      },
      "required": false
    },
    "wrapperContainer": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "\"300px\"",
        "computed": false
      },
      "required": false
    }
  }
};

function AppFormFieldJSON(_ref) {
  let {
    name,
    onChange = () => {},
    formFieldContainerStyle,
    ...otherProps
  } = _ref;
  const {
    setFieldTouched,
    setFieldValue,
    errors,
    touched,
    initialValues,
    values
  } = useFormikContext();
  const stringifiedError = errors[name] && typeof errors[name] === "object" ? JSON.stringify(errors[name]) : errors[name];
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      paddingBottom: Constants.ERROR_OFFSET * 3
    }, formFieldContainerStyle]
  }, /*#__PURE__*/React__default.createElement(AppJSONEditor, _extends({
    json: initialValues && initialValues[name],
    onBlur: () => setFieldTouched(name),
    onValueChange: value => {
      setFieldValue(name, value === null || value === void 0 ? void 0 : value.json);
      onChange(value);
    }
  }, otherProps)), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: stringifiedError
  }));
}
AppFormFieldJSON.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormFieldJSON",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

function AppFormMultipleSelection(_ref) {
  let {
    name,
    OptionItem = AppMultipleSelectionItem,
    onSelectItem,
    formOptionValue,
    ...otherProps
  } = _ref;
  const {
    setFieldValue,
    setFieldTouched,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppMultipleSelection, _extends({
    placeholder: placeholder,
    onBlur: () => setFieldTouched(name),
    OptionItem: OptionItem,
    onSelectItem: item => {
      setFieldValue(name, formOptionValue ? item[formOptionValue] : item);
      onSelectItem(item);
    },
    selectedItem: values && values[name]
  }, otherProps)), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: errors[name]
  }));
}
AppFormMultipleSelection.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormMultipleSelection",
  "props": {
    "OptionItem": {
      "defaultValue": {
        "value": "AppMultipleSelectionItem",
        "computed": true
      },
      "required": false
    }
  }
};

function AppFormSwitch(_ref) {
  let {
    value,
    setValue,
    name,
    ...otherProps
  } = _ref;
  const {
    setFieldValue,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppSwitch, _extends({
    onChange: b => setFieldValue(name, b),
    isTicked: values && values[name]
  }, otherProps)), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: errors[name]
  }));
}
AppFormSwitch.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormSwitch"
};

function AppFormDropDown(_ref) {
  let {
    name,
    formFieldContainerStyle,
    forcedValue,
    _onValueChange = () => {},
    wrapperContainerStyle,
    ...otherProps
  } = _ref;
  const {
    setFieldValue,
    setFieldTouched,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  useEffect(() => {
    if (forcedValue) {
      setFieldValue(name, forcedValue);
    }
  }, [forcedValue]);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      paddingBottom: Constants.ERROR_OFFSET * 2
    }, formFieldContainerStyle]
  }, /*#__PURE__*/React__default.createElement(AppDropDown, _extends({
    wrapperContainer: [{
      margin: 5
    }, wrapperContainerStyle],
    onBlur: () => setFieldTouched(name),
    selectedValue: values && values[name],
    onValueChange: item => {
      setFieldValue(name, item);
      _onValueChange && _onValueChange(item);
    }
  }, otherProps)), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: errors[name]
  }));
}
AppFormDropDown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormDropDown",
  "props": {
    "_onValueChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

function AppFormRadio(_ref) {
  let {
    name,
    onSelectionChange = () => {},
    ...otherProps
  } = _ref;
  const {
    setFieldValue,
    setFieldTouched,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  return /*#__PURE__*/React__default.createElement(View, {
    style: {
      paddingBottom: Constants.ERROR_OFFSET * 2
    }
  }, /*#__PURE__*/React__default.createElement(AppRadio, _extends({
    wrapperContainer: {
      margin: 5
    },
    selectedOption: values && values[name],
    onSelectionChange: item => {
      setFieldTouched(name);
      setFieldValue(name, item);
      onSelectionChange(item);
    }
  }, otherProps)), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: errors[name]
  }));
}
AppFormRadio.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormRadio",
  "props": {
    "onSelectionChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

function AppFormSecureTexInput(_ref) {
  let {
    name,
    onChange = () => {},
    wrapperStyle,
    containerWrapperStyle,
    ...otherProps
  } = _ref;
  const {
    setFieldTouched,
    setFieldValue,
    errors,
    touched,
    initialValues,
    values
  } = useFormikContext();
  const [inputValue, setInputValue] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const onChangeValue = value => {
    setInputValue(value);
    onChange(value);
    setFieldValue(name, value);
  };
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      paddingBottom: Constants.ERROR_OFFSET * 3
    }, containerWrapperStyle]
  }, /*#__PURE__*/React__default.createElement(AppSecureTextInput, _extends({
    showValue: true
  }, otherProps, {
    showTextInputLabel: true,
    style: {
      width: "100%",
      paddingHorizontal: 10
    },
    coreViewStyle: {
      minHeight: 40
    },
    wrapperStyle: [{
      flex: 1,
      flexDirection: "row"
    }, wrapperStyle],
    actionsButtonsViewStyle: {
      paddingRight: 10
    },
    isEditable: isEditing,
    onEditIconPress: () => setIsEditing(true),
    onCancelIconPress: () => setIsEditing(false),
    onSubmitIconPress: v => {
      onChangeValue(v);
      setIsEditing(false);
    },
    initialValue: values && values[name] || initialValues && initialValues[name]
  })), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: errors[name]
  }));
}
AppFormSecureTexInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormSecureTexInput",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

function AppFormMultiSelect(_ref) {
  var _values$name;
  let {
    name,
    items,
    onSelectionChange = () => {},
    labelOption = "name",
    groupByProperty = "category",
    uniqueKey = "id",
    topErrorOffset,
    touchedByDefault,
    ...props
  } = _ref;
  const [fakeKey, setFakeKey] = React__default.useState("null");
  const [counter, setCounter] = React__default.useState(0);
  const {
    setFieldValue,
    setFieldTouched,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  useEffect(() => {
    if (counter === 0) {
      setFakeKey(Date.now().toString());
    }
    setCounter(prev => prev + 1);
  }, [values[name]]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppMultipleSelectInput, _extends({
    key: fakeKey,
    onSelectionChange: items => {
      setFieldValue(name, items);
      onSelectionChange(items);
      setFieldTouched(name, true);
    },
    selectedItems: (_values$name = values[name]) === null || _values$name === void 0 ? void 0 : _values$name.filter(item => item === null || item === void 0 ? void 0 : item.value),
    placeholder: placeholder,
    hidePlaceholder: true,
    items: items,
    showDropDowns: true,
    readOnlyHeadings: true,
    labelOption: labelOption,
    groupByProperty: groupByProperty,
    uniqueKey: uniqueKey
  }, props)), (touched[name] || touchedByDefault) && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: errors[name],
    top: topErrorOffset
  }));
}
AppFormMultiSelect.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormMultiSelect",
  "props": {
    "onSelectionChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "labelOption": {
      "defaultValue": {
        "value": "\"name\"",
        "computed": false
      },
      "required": false
    },
    "groupByProperty": {
      "defaultValue": {
        "value": "\"category\"",
        "computed": false
      },
      "required": false
    },
    "uniqueKey": {
      "defaultValue": {
        "value": "\"id\"",
        "computed": false
      },
      "required": false
    }
  }
};

class JSONEditorDemo extends Component {
  toggleDarkMode() {
    this.setState(prevState => ({
      darkMode: !prevState.darkMode
    }));
  }
  componentDidMount() {
    const options = {
      mode: this.props.mode || "tree",
      onChangeJSON: this.props.onChangeJSON,
      onChangeText: this.props.onChangeText,
      onValidate: this.props.onValidate
    };
    this.jsoneditor = new JSONEditor(this.container, options);
    this.jsoneditor.set(this.props.json);
  }
  componentWillUnmount() {
    if (this.jsoneditor) {
      this.jsoneditor.destroy();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.json && typeof this.props.json === "object" && !_.isEqual(this.props.json, prevProps.json)) {
      this.jsoneditor.set(this.props.json || {});
    }
  }
  render() {
    return /*#__PURE__*/React__default.createElement(View, {
      style: [{
        display: "flex",
        flexDirection: "column"
      }, this.props.wrapperContainer]
    }, this.props.showTextInputLabel ? /*#__PURE__*/React__default.createElement(AppInputLabel, {
      style: [{
        marginLeft: 20
      }, this.props.textInputLabelStyle],
      isMandatory: this.props.isMandatory,
      label: this.props.label
    }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), /*#__PURE__*/React__default.createElement("div", {
      className: "jsoneditor-react-container ".concat(this.props.darkMode ? "dark" : "light"),
      ref: elem => this.container = elem
    }));
  }
}
JSONEditorDemo.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "toggleDarkMode",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "JSONEditorDemo"
};

function AppFormFieldJSONV2(_ref) {
  let {
    name,
    onChange = () => {},
    onValidate = () => {},
    formFieldContainerStyle,
    errorMessageTopOffset,
    ...otherProps
  } = _ref;
  const {
    setFieldTouched,
    setFieldValue,
    errors,
    touched,
    initialValues,
    values,
    setErrors
  } = useFormikContext();
  const stringifiedError = errors[name] && typeof errors[name] === "object" ? JSON.stringify(errors[name]) : errors[name];
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      paddingBottom: Constants.ERROR_OFFSET * 3
    }, formFieldContainerStyle]
  }, /*#__PURE__*/React__default.createElement(JSONEditorDemo, _extends({
    json: initialValues && initialValues[name],
    onBlur: () => setFieldTouched(name),
    onChangeJSON: value => {
      setFieldValue(name, value);
      onChange(value);
    },
    onValidate: json => {
      return onValidate(json);
    },
    onChangeText: value => {
      try {
        if (value != null && value.length != 0) {
          const _json = JSON.parse(value);
          setFieldValue(name, _json);
          onChange(_json);
        }
      } catch (e) {
        setErrors({
          [name]: "Invalid JSON"
        });
      }
    }
  }, otherProps)), errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: stringifiedError,
    top: errorMessageTopOffset
  }));
}
AppFormFieldJSONV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormFieldJSONV2",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onValidate": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

function AppFormSlider(_ref) {
  let {
    name,
    label,
    maximumValue,
    minimumValue,
    unitLabel,
    wrapperStyle,
    containerStyle,
    ...otherProps
  } = _ref;
  const {
    setFieldValue,
    setFieldTouched,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  const [isTrainingIterationsEditable, setIsTrainingIterationsEditable] = useState(false);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      paddingBottom: Constants.ERROR_OFFSET * 2
    }, containerStyle]
  }, /*#__PURE__*/React__default.createElement(AppSecureTextInput, _extends({
    inputType: "SLIDER",
    showValue: true,
    label: label,
    showTextInputLabel: true,
    style: {
      width: "100%",
      paddingHorizontal: 10
    },
    coreViewStyle: {
      minHeight: 40
    },
    wrapperStyle: [{
      flex: 1,
      flexDirection: "row"
    }, wrapperStyle],
    maximumValue: maximumValue,
    minimumValue: minimumValue,
    actionsButtonsViewStyle: {
      paddingRight: 10
    },
    isEditable: isTrainingIterationsEditable,
    onEditIconPress: () => setIsTrainingIterationsEditable(true),
    onCancelIconPress: () => setIsTrainingIterationsEditable(false),
    onSubmitIconPress: v => {
      setIsTrainingIterationsEditable(false);
      setFieldValue(name, v);
    },
    initialValue: values[name],
    unitLabel: unitLabel
  }, otherProps)), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: errors[name]
  }));
}
AppFormSlider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormSlider"
};

function AppFOrmCodeEditor(_ref) {
  let {
    value,
    setValue,
    name,
    ...otherProps
  } = _ref;
  const {
    setFieldValue,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppCodeEditor, _extends({
    setValue: b => setFieldValue(name, b),
    value: values && values[name]
  }, otherProps)), errors[name] && values[name] != "" && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    top: -18,
    message: errors[name]
  }));
}
AppFOrmCodeEditor.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFOrmCodeEditor"
};

const getFormData = (object, _ref) => {
  let [exclusionKeys] = _ref;
  const formData = new FormData();
  Object.keys(object).forEach(key => {
    if (!exclusionKeys.includes(key)) formData.append(key, object[key]);
  });
  return formData;
};
var AppFormUtilities = {
  getFormData
};

var AppForms = {
  AppForm,
  AppFormField,
  AppErrorMessage,
  AppSubmitButton,
  AppFormMultipleSelection,
  AppFormPicker,
  AppFormSwitch,
  AppFormDropDown,
  AppFormRadio,
  AppFormUtilities,
  yup: Yup,
  useFormikContext,
  AppFormCodeInput,
  AppFormSecureTextInput: AppFormSecureTexInput,
  AppFormSlider,
  AppFormMultiSelect,
  AppFormFieldJSON,
  AppFormFieldJSONV2,
  AppFormCodeEditor: AppFOrmCodeEditor
};

export { AppForms as A };
